import { List, Stack, Text } from '@chakra-ui/react'
import { Rich, useT } from '~/i18n/use-t'

/** The body of the FAQ entry `locationAllow` (the entry's question is its title). */
export function LocationHelp() {
  const { t } = useT()
  return (
    <Stack gap={4}>
      <Text fontWeight='bold'>{t('locationHelp.allow')}</Text>
      <List.Root ps={6} gap={2}>
        {['android', 'iphone', 'chromeEdge', 'firefox'].map((k) => (
          <List.Item key={k}>
            <Rich k={`locationHelp.${k}`} />
          </List.Item>
        ))}
      </List.Root>
      <Text fontWeight='bold'>{t('locationHelp.preciseTitle')}</Text>
      <List.Root ps={6} gap={2}>
        {['preciseIphone', 'preciseAndroid'].map((k) => (
          <List.Item key={k}>
            <Rich k={`locationHelp.${k}`} />
          </List.Item>
        ))}
      </List.Root>
    </Stack>
  )
}
